'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';

import { Button } from '@/vibes/soul/primitives/button';
import { ButtonLink } from '@/vibes/soul/primitives/button-link';
import { PopularCategories } from '~/components/navigation/popular-categories';
import { withSentry } from '~/lib/sentry-client';

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ErrorPage({ error, reset }: Props) {
  const t = useTranslations('Error');

  useEffect(() => {
    withSentry((Sentry) => Sentry.captureException(error));
  }, [error]);

  return (
    <div className="mx-auto max-w-4xl px-4 py-16 text-center sm:px-6 sm:py-24 lg:px-8">
      <h1 className="mb-4 text-4xl tracking-tight text-foreground sm:text-5xl">
        {t('title')}
      </h1>

      <p className="mb-8 text-lg text-muted-foreground">{t('subtitle')}</p>

      <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
        <Button onClick={() => reset()} variant="primary" size="large">
          {t('cta')}
        </Button>
        <ButtonLink href="/" variant="secondary" size="large">
          Back to Home
        </ButtonLink>
      </div>

      <PopularCategories />
    </div>
  );
}
